import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Component } from '@angular/core';
import { AuthService } from '../../auth.service';
import { isCountryCodeBelgian } from '../../../shared/countries/country-service';

@Component({
  selector: 'app-sso-login',
  templateUrl: './sso-login.component.html',
  styleUrls: ['./sso-login.component.scss'],
})
export class SsoLoginComponent {
  constructor(public oidcSecurityService: OidcSecurityService, private readonly authService: AuthService) {}

  get mottoKey(): string {
    return isCountryCodeBelgian(this.authService.getCountry()) ? 'login.motto_be' : 'login.motto';
  }

  login(): void {
    this.oidcSecurityService.authorize();
  }
}
